import React from 'react';
import Appearance from 'styles/Appearance.js';
import config from 'files/api.js';
import PageLayout from 'views/PageLayout.js';

const ShippingPage = () => {

    const sections = [
        { h: 'Free standard shipping', p: 'Every order ships free within the contiguous United States — no hidden handling fees at checkout.' },
        { h: 'Order processing', p: 'Orders are typically processed within 1–2 business days. You’ll receive an email confirmation as soon as your order is placed.' },
        { h: 'Delivery time', p: 'Once shipped, standard delivery usually takes 3–7 business days, depending on your location.' },
        { h: 'Tracking your order', p: 'As soon as your order ships, we’ll email you a tracking number so you can follow it right to your door.' },
        { h: 'Where we ship', p: 'We currently ship within the United States. If you have a question about a specific address, our support team is happy to help.' },
        { h: 'Damaged or missing packages', p: `If your order arrives damaged or doesn’t arrive, contact us at ${config.store.email} and we’ll make it right.` },
    ];

    return (
        <PageLayout
            eyebrow={'Shipping'}
            title={'Shipping policy'}
            subtitle={'How and when your Aqua Link order gets to you.'}>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
                {sections.map((s, index) => (
                    <div key={index} style={{ borderTop: index === 0 ? 'none' : `1px solid ${Appearance.colors.border()}`, paddingTop: index === 0 ? 0 : 28 }}>
                        <h2 style={{ ...Appearance.textStyles.subHeading({ fontSize: 19 }), marginBottom: 10 }}>{s.h}</h2>
                        <p style={Appearance.textStyles.body({ fontSize: 16, lineHeight: 1.6 })}>{s.p}</p>
                    </div>
                ))}
            </div>
        </PageLayout>
    );
};

export default ShippingPage;
